import { Container } from '@mui/material'
import Body from 'components/common/Body'
import Filters from 'components/HookmanQualifiedList/Filters'
import SubHeader from 'components/layout/SubHeader'
import ApplicationFooter from 'components/layout/ApplicationFooter'
import BusinessUnitSelector from 'components/common/BusinessUnitSelector'
import MembersList from 'components/HookmanQualifiedList/MembersList'
import { ISearchMyStaffParams } from 'interfaces'
import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import {
  selectSelectedBusinessUnits,
  selectHookmanSelectedFilters,
  selectHookmanSelectedJobRole,
  selecHookmanSelectedSearchString,
  selectHookmanTableConfig,
  useAppSelector,
  useAppDispatch,
  setHookmanSearchString,
} from 'store'

import { useLazySearchSafetyAccompanyingPersonsQuery } from 'store/api'
import { removeEmptyValues } from 'utils/objectHandlers'

const HookmanQualifiedList = () => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const q = searchParams.get('q')
  const dispatch = useAppDispatch()

  const [shouldRefetch, setShouldRefetch] = useState(false)
  const selectedFilters = useAppSelector(selectHookmanSelectedFilters)
  const tableConfig = useAppSelector(selectHookmanTableConfig)
  const selectedJobRole = useAppSelector(selectHookmanSelectedJobRole)
  const selectedSearchString = useAppSelector(selecHookmanSelectedSearchString)
  const selectedBusinessUnits = useAppSelector(selectSelectedBusinessUnits)

  const selectedBusinesUnitsValues = selectedBusinessUnits.map(bu => bu.value)

  const myStaffFilters: ISearchMyStaffParams = {
    ...tableConfig,
    ...selectedFilters,
    searchTerm: selectedSearchString,
    jobRoles: selectedJobRole,
    businessUnits: selectedBusinesUnitsValues,
  }

  const [getSafetyAccompanyingPersons, { data: safetyAccompanyingData, isFetching }] =
    useLazySearchSafetyAccompanyingPersonsQuery()

  const handleSearchSafetyAccompanyingPersons = () => {
    try {
      getSafetyAccompanyingPersons(removeEmptyValues(myStaffFilters))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleSearchSafetyAccompanyingPersons()
  }, [tableConfig, shouldRefetch])

  useEffect(() => {
    if (id || q) {
      dispatch(setHookmanSearchString(q || id || ''))
      setShouldRefetch(!shouldRefetch)
    }
  }, [id, q])

  if (!safetyAccompanyingData) return null
  const { records, totalPages, totalRecords } = safetyAccompanyingData

  return (
    <>
      <Body>
        <SubHeader
          breadcrumbItems={[
            {
              text: <FormattedMessage id="app.labels.dashboard" />,
              href: '/dashboard',
            },
            {
              text: <FormattedMessage id="app.labels.hookmanQualifiedList" />,
              href: '/view-safety-accompanying-person-list',
            },
          ]}
        >
          <BusinessUnitSelector
            setShouldRefetch={setShouldRefetch}
            shouldRefetch={shouldRefetch}
          />
        </SubHeader>
        <Filters setShouldRefetch={setShouldRefetch} shouldRefetch={shouldRefetch} />

        <Container>
          <MembersList
            isLoading={isFetching}
            records={records}
            totalPages={totalPages}
            totalRecords={totalRecords}
          />
        </Container>
      </Body>

      <ApplicationFooter />
    </>
  )
}

export default HookmanQualifiedList
